import React, { useState } from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";

const Suscribe = () => {
  const mailchimpUrl =
    "https://gmail.us7.list-manage.com/subscribe/post?u=60e26ff821432dff67927f7d3&amp;id=7254af17f2";
  const [email, setEmail] = useState("");

  return (
    <section
      id="newsletter-section"
      className="cs cs2 subscribe-section s-py-60 s-py-xl-70"
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <h4 className="mb-4 mb-lg-0">Become a JMTY insider</h4>
            <p style={{ margin: "20px 0", maxWidth: "450px" }}>
              Enter your email address to receive our newsletters and tips to
              help you thrive in the U.S.
            </p>
          </div>

          <div className="col-lg-6 text-center">
            <div className="widget widget_mailchimp pencil">
              <MailchimpSubscribe
                url={mailchimpUrl}
                render={({ subscribe, status, message }) => (
                  <>
                    <form
                      className="signup"
                      onSubmit={e => {
                        e.preventDefault();
                        subscribe({ EMAIL: email });
                      }}
                    >
                      <label htmlFor="mailchimp_email">
                        <span className="screen-reader-text">Subscribe:</span>
                      </label>

                      <input
                        id="mailchimp_email"
                        name="email"
                        type="email"
                        className="form-control mailchimp_email"
                        placeholder="Enter Email Address"
                        onChange={e => setEmail(e.target.value)}
                      />

                      <button type="submit" className="search-submit">
                        <span>SUBSCRIBE</span>
                      </button>
                    </form>
                    {status && (
                      <div className="response text-capitalize" style={{color: "#FFFFFF"}}>
                        <span>{status}</span>
                        {"! "}
                        <span
                          dangerouslySetInnerHTML={{ __html: message }}
                        ></span>
                      </div>
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Suscribe;
